/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Contract_BannerInputs */



/**
* | output |
* | --- |
* | "This period is covered by the customer's contract and is not invoiced. The figures are for review." |
*
* @param {Partner_Billing_Contract_BannerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_contract_banner = /** @type {((inputs?: Partner_Billing_Contract_BannerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Contract_BannerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Dieser Zeitraum ist durch den Vertrag des Kunden abgedeckt und wird nicht berechnet. Die Zahlen dienen der Prüfung.")
	return /** @type {LocalizedString} */ ("This period is covered by the customer's contract and is not invoiced. The figures are for review.")
});